import { render, staticRenderFns } from "./ExpertCenter.vue?vue&type=template&id=cc9c0c94"
import script from "./ExpertCenter.vue?vue&type=script&lang=js"
export * from "./ExpertCenter.vue?vue&type=script&lang=js"
import style0 from "./ExpertCenter.vue?vue&type=style&index=0&id=cc9c0c94&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports